/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import Link from 'components/Link';
import Byline from 'routes/articleshow_v2/components/common/Byline';
import Text from 'routes/articleshow_v2/components/common/Text';
import { isStoryPageNewVariant, getSeoName } from 'utils/primeUtil';
import ClientOnly from '../ClientOnly';
import s from './StoryCard.scss';
import RightSection from '../RightSection/RightSection';
import { gaWrapper } from '../../../../../helpers/analytics';

import CardComponent from '../OverlayCard/OverlayCard';
import { TIMES_SPECIAL_NOC_NAME } from '../../../../../constants';

const StoryCard = props => {
  const { msid, isWapView, storyPageData, fireGA, userData } = props;
  const [isOpen, setOpen] = useState(false);
  const openModalClick = () => {
    try {
      const body = document.querySelector('body');
      body.classList.add('disable-scroll');
    } catch (err) {
      throw err;
    }
    fireGA('View_cards');
    setOpen(true);
  };
  const closePopup = () => {
    try {
      const body = document.querySelector('body');
      body.classList.remove('disable-scroll');
    } catch (err) {
      throw err;
    }
    setOpen(false);
  };

  const customStylesModalMobile = {
    content: {
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      border: '0',
      borderRadius: '0',
      overflow: 'initial',
      background: 'transparent',
      padding: '20px 16px',
    },
    overlay: {
      zIndex: '1003',
      background: 'rgba(0, 0, 0, 0.7)',
    },
  };
  if (!storyPageData) {
    return null;
  }

  const getNonPrimeImage = () => {
    const { images } = storyPageData;
    if (!images || !images.length > 0) {
      return null;
    }
    const defaultImage = images[0];
    const webImage = images?.find(
      el => el?.payload?.toLowerCase() === 'OverrideLeadImage'.toLowerCase(),
    );
    if (isWapView) return defaultImage;
    if (storyPageData.metaInfo?.Hideheadline === '1') {
      return webImage || defaultImage;
    }
    return webImage || defaultImage;
  };

  const isCreativeHeadline = (getCreativeProp = false) => {
    let tempData = null;
    const { images } = storyPageData;
    if (!images || !images?.length > 0) {
      return false;
    }
    images.forEach(el => {
      if (
        el?.payload?.toLowerCase() === 'OverrideLeadImage'.toLowerCase() &&
        el.templatedata
      ) {
        tempData = el.templatedata;
      }
      if (el?.payload === '' && el.templatedata && !tempData) {
        tempData = el.templatedata;
      }
    });
    if (getCreativeProp) {
      return tempData;
    }
    return !!tempData;
  };

  const getArticleshpwDate = () => {
    let dateStr = '';
    let updatedText = '';
    if (storyPageData.dl && storyPageData.upd) {
      const updatedNum = parseInt(storyPageData.upd, 10);
      const createdNum = parseInt(storyPageData.dl, 10);
      if (updatedNum - createdNum > 60000) {
        dateStr = storyPageData.updStr;
        updatedText = 'Updated:';
      } else {
        dateStr = storyPageData.dlStr;
      }

      dateStr = `${updatedText} ${dateStr} IST`;
    }

    return dateStr;
  };

  const hideHeadline = storyPageData.metaInfo?.Hideheadline === '1';

  const hideImage = storyPageData.metaInfo?.Generic === 'NoImage';

  const nocName = storyPageData.metaInfo?.NatureOfContent;

  const getComponents = data => {
    let component = '';
    if (data.tn) {
      switch (data.tn) {
        case 'text':
          component = <Text value={data.value} styleObj={s} prime />;
          break;
        case 'link':
          component = <Link href={data.wu}>{data.value}</Link>;
          break;
        case 'keyword':
          component = data.value;
          break;
        case 'br':
          component = <br />;
          break;
        default:
          component = '';
      }
    }
    return component;
  };

  return (
    <div
      className={`${s.container} ${
        isStoryPageNewVariant() ? s.storyblockernewWrapper : ''
      }`}
    >
      {isWapView ? (
        <>
          <Breadcrumbs data={storyPageData} userData={userData} />
          <Heading heading={storyPageData.hl} />
          <div>
            {nocName && getSeoName(nocName) === TIMES_SPECIAL_NOC_NAME ? (
              <span className={s.timesSpecialLogo} />
            ) : null}
            {isStoryPageNewVariant() ? (
              <Byline
                dl={storyPageData.dl || ''}
                dlStr={storyPageData.dlStr || ''}
                updStr={storyPageData.updStr || ''}
                upd={storyPageData.upd}
                isWapView={isWapView}
                toipLayout
                author={storyPageData.authors}
                ag={storyPageData.ag}
                newStoryPage
              />
            ) : (
              <ClientOnly>
                <Byline
                  dl={storyPageData.dl || ''}
                  dlStr={storyPageData.dlStr || ''}
                  updStr={storyPageData.updStr || ''}
                  upd={storyPageData.upd}
                  isWapView={isWapView}
                  toipLayout
                  // tag={tag}
                  author={storyPageData.authors}
                  ag={storyPageData.ag}
                />
              </ClientOnly>
            )}
          </div>
          {!hideImage &&
            (isStoryPageNewVariant() ? (
              <div className={s.imageWrapper}>
                <ImageComponent
                  imgObj={getNonPrimeImage()}
                  hasVideo={storyPageData.hasVideo}
                  width="350"
                  height="197"
                  nocName={nocName}
                  hasAudio={storyPageData.hasAudio}
                />
                {storyPageData.syn &&
                  isStoryPageNewVariant() && (
                    <div className={s.highlights}>
                      <p>{storyPageData.syn}</p>
                    </div>
                  )}
              </div>
            ) : (
              <ImageComponent
                imgObj={getNonPrimeImage()}
                hasVideo={storyPageData.hasVideo}
                width="350"
                height="197"
                nocName={nocName}
                hasAudio={storyPageData.hasAudio}
              />
            ))}
        </>
      ) : (
        <>
          {isCreativeHeadline() ? (
            <div className={`${s.topSection} ${s.creativeHeader}`}>
              <ImageComponent
                imgObj={getNonPrimeImage()}
                hasVideo={storyPageData.hasVideo}
                width="800"
                height="450"
                nocName={nocName}
                hasAudio={storyPageData.hasAudio}
              />
              <Heading
                heading={storyPageData.hl}
                creativeProp={isCreativeHeadline(true)}
              />
            </div>
          ) : hideImage ? (
            <Heading heading={storyPageData.hl} />
          ) : hideHeadline ? (
            <div className={`${s.topSection}`}>
              <ImageComponent
                imgObj={getNonPrimeImage()}
                hasVideo={storyPageData.hasVideo}
                width="800"
                height="450"
                nocName={nocName}
                hasAudio={storyPageData.hasAudio}
              />
            </div>
          ) : (
            <div className={`${s.topSection}`}>
              <div className={s.leadimage_heading}>
                <Heading className={s.heading} heading={storyPageData.hl} />
              </div>
              <ImageComponent
                imgObj={getNonPrimeImage()}
                hasVideo={storyPageData.hasVideo}
                width="800"
                height="450"
                nocName={nocName}
                hasAudio={storyPageData.hasAudio}
              />
            </div>
          )}
          <div className={s.bylineWrapper}>
            {nocName && getSeoName(nocName) === TIMES_SPECIAL_NOC_NAME ? (
              <span className={s.timesSpecialLogo} />
            ) : null}
            <div>
              <div className={s.breadcrumbWrapper}>
                {nocName && getSeoName(nocName) !== TIMES_SPECIAL_NOC_NAME ? (
                  <Breadcrumbs data={storyPageData} userData={userData} />
                ) : null}
                <Byline
                  dl={storyPageData.dl || ''}
                  dlStr={storyPageData.dlStr || ''}
                  updStr={storyPageData.updStr || ''}
                  upd={storyPageData.upd}
                  isWapView={isWapView}
                  toipLayout
                  // tag={tag}
                />
              </div>
              {/* <Heading heading={storyPageData.hl} /> */}
              <div
                className={`${s.metaInfo} ${
                  !isWapView ? s.storyDateContainer : ''
                }`}
              >
                {isStoryPageNewVariant() ? (
                  <ul>
                    {Array.isArray(storyPageData.authors) &&
                      storyPageData.authors.length > 0 && (
                        <li className={s.authors}>
                          {storyPageData.authors.map(author => {
                            const authorUrl = `/toi-plus/author-${author.name
                              ?.replace(/ /g, '')
                              .toLowerCase()}-${author.id}`;
                            return (
                              <Link
                                className={s.authorItem}
                                key={author.id}
                                to={authorUrl}
                              >
                                {author.name}
                              </Link>
                            );
                          })}
                        </li>
                      )}
                    <li>
                      {storyPageData.ag && (
                        <span className={s.agency}>{storyPageData.ag}</span>
                      )}
                      {!isWapView && <span>{getArticleshpwDate()}</span>}
                    </li>
                  </ul>
                ) : (
                  <>
                    <ul>
                      {Array.isArray(storyPageData.authors) &&
                        storyPageData.authors.length > 0 && (
                          <li className={s.authors}>
                            {storyPageData.authors.map(author => {
                              const authorUrl = `/toi-plus/author-${author.name
                                ?.replace(/ /g, '')
                                .toLowerCase()}-${author.id}`;
                              return (
                                <Link
                                  className={s.authorItem}
                                  key={author.id}
                                  to={authorUrl}
                                >
                                  {author.name}
                                </Link>
                              );
                            })}
                          </li>
                        )}
                      {storyPageData.ag && (
                        <li className={s.agency}>
                          <span>{storyPageData?.ag}</span>
                        </li>
                      )}
                    </ul>
                    {!isWapView && <span>{getArticleshpwDate()}</span>}
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}
      <>
        {isWapView &&
          !isStoryPageNewVariant() && (
            <RightSection
              isWapView
              msid={msid}
              openModalClick={openModalClick}
              fireGA={fireGA}
            />
          )}
      </>
      {storyPageData.syn &&
        isStoryPageNewVariant() &&
        !isWapView && (
          <div className={s.highlights}>
            <p>{storyPageData.syn}</p>
          </div>
        )}

      {storyPageData.story?.length > 0 && (
        <div className={`${s.description} paywall`}>
          {storyPageData.story.map(el => getComponents(el))}
        </div>
      )}

      {isOpen && (
        <Modal
          isOpen={isOpen}
          onRequestClose={closePopup}
          style={customStylesModalMobile}
          contentLabel="Example Modal"
          itemIndex
        >
          <div className={s.modalWrapper}>
            <button onClick={closePopup} className={s.CloseBtn} />
            <div className={s.modalDetails}>
              <CardComponent isWapView msid={msid} />
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

const Breadcrumbs = ({ data, userData }) => {
  if (!data) {
    return null;
  }
  const noc = data.metaInfo?.NatureOfContent;
  const nocUrl = noc
    ? `/toi-plus/noc/${noc.replace(' ', '-')?.toLowerCase()}`
    : null;
  const taxonomy = data.taxonomy && data.taxonomy?.decode;
  const taxonomyUrl = data.taxonomy && data.taxonomy?.url;
  const breadcrumbs = [
    // { value: sectionName, wu: sectionUrl },
    { value: taxonomy, wu: taxonomyUrl },
    { value: noc, wu: nocUrl },
  ];

  const handleBreadcrumbsClick = () => {
    const topicTree = data.metaInfo?.TopicTree;
    const isLoggedIn =
      userData && userData.isLoggedIn ? userData.isLoggedIn : false;
    const prcValue = userData && userData.prcValue ? userData.prcValue : 0;
    gaWrapper(
      'send',
      'event',
      'TOI Plus',
      `TOIPlus_taxonomyLabel_${topicTree}_click`,
      `Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`,
    );
  };

  return (
    <div className={s.cardCategory}>
      {breadcrumbs.map(
        (el, i) =>
          el.value &&
          el.wu && (
            <Link
              className={s.cardCategoryLink}
              key={`${el}_${i}`}
              to={el.wu}
              rel="noopener"
              onClick={handleBreadcrumbsClick}
            >
              {el.value}
            </Link>
          ),
      )}
    </div>
  );
};

const Heading = ({ heading, creativeProp }) => (
  <h1
    className={`${s.heading} ${creativeProp?.templatename?.toLowerCase()}`}
    style={{
      color: creativeProp?.fontcolor,
      background: creativeProp?.background,
      textAlign: creativeProp?.fontalign,
      fontFamily: creativeProp?.fontfamily,
      fontSize: creativeProp?.fontsize,
      textTransform: creativeProp?.transform,
    }}
    dangerouslySetInnerHTML={{
      __html: heading,
    }}
  />
);

const ImageComponent = ({
  imgObj,
  hasVideo,
  width,
  height,
  hasAudio,
  nocName,
}) => {
  const scrollToBlocker = () => {
    const blockerElement =
      typeof window !== 'undefined' &&
      document.getElementById('story-blocker-new');
    if (
      blockerElement &&
      typeof blockerElement.scrollIntoView === 'function' &&
      (hasVideo || hasAudio)
    ) {
      blockerElement.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <div className={s.imgContainer} onClick={scrollToBlocker}>
      <div className={`${s.content}`}>
        {(hasVideo || hasAudio) && <span className={s.playIcon} />}
        {nocName &&
          getSeoName(nocName) === TIMES_SPECIAL_NOC_NAME &&
          imgObj?.id && (
            <img
              src={`https://static.toiimg.com/thumb/width-${width},height-${height},${
                imgObj?.imagesize ? `imgsize-${imgObj.imagesize}` : ''
              },msid-${imgObj?.id},resizemode-75/${imgObj?.id}.jpg`}
              alt=""
            />
          )}
        {!(nocName && getSeoName(nocName) === TIMES_SPECIAL_NOC_NAME) &&
          imgObj?.id && (
            <img
              src={`https://static.toiimg.com/thumb/width-${width},height-${height},${
                imgObj?.imagesize ? `imgsize-${imgObj.imagesize}` : ''
              },msid-${imgObj?.id}/${imgObj?.id}.jpg`}
              alt=""
            />
          )}
      </div>
    </div>
  );
};

StoryCard.propTypes = {
  isWapView: PropTypes.bool,
  msid: PropTypes.string,
  fireGA: PropTypes.func.isRequired,
  userData: PropTypes.shape({
    prcValue: PropTypes.number,
    isLoggedIn: PropTypes.bool,
  }),
};

StoryCard.defaultProps = {
  isWapView: false,
  msid: '',
  userData: {},
};

const mapStateToProps = (state, ownProps) => ({
  storyPageData: _get(state, `toiplusprimeshow.data[${ownProps.msid}]`, null),
  // tag: _get(state, 'toiplusprimeshow.decode', ''),
});

export default connect(mapStateToProps)(StoryCard);
